import { JastBuilder, walkAST } from '@atlaskit/jql-ast';
import {
	ASSIGNEE,
	LABEL,
	TEXT,
	type FilterType,
	type Filters,
} from '../../model/filter/filter-types.tsx';
import { getOperandValues } from './get-operand-values.tsx';

export const getWorkFiltersFromJql = (jql: string): Filters => {
	const ast = new JastBuilder().build(jql);

	const workFilters: Filters = {};

	walkAST(
		{
			enterTerminalClause(terminalClause) {
				const field = terminalClause.field.value.toLowerCase();
				const workFilter = mapFieldJqlTermToWorkFilter(field);

				if (workFilter && terminalClause.operand) {
					const operandValues = getOperandValues(terminalClause.operand);

					switch (workFilter) {
						case ASSIGNEE:
							workFilters[workFilter] = operandValues.map((name) =>
								name === 'empty' ? 'unassigned' : name,
							);
							break;
						case TEXT:
							workFilters[workFilter] = operandValues[0];
							break;
						case LABEL:
							workFilters[workFilter] = operandValues;
							break;
						default:
							break;
					}
				}
			},
		},
		ast,
	);

	return workFilters;
};

const mapFieldJqlTermToWorkFilter = (jqlTerm: string): FilterType | null => {
	switch (jqlTerm) {
		case 'assignee':
			return ASSIGNEE;
		case 'textfields':
			return TEXT;
		case 'labels':
			return LABEL;
		default:
			return null;
	}
};
